import Rest from 'services/data/rest';
import axios from 'axios';
import Promise from 'bluebird';
import * as alerts from 'modules/alerts/actions';

export default class Settings extends Rest {
  static path = 'auth';
  static defaultQuery = {};

  static sync(body) {
    return Promise.resolve(axios.post('/api/auth/sync', body))
      .tap(this.logRequest)
      .then((response) => response.data);
  }

  static resetPassword(user) {
    return Promise.resolve(axios.put('/api/auth/reset-password', { id: user.id }))
      .tap(this.logRequest)
      .tap(() => {
        alerts.success({ title: 'Password Reset', subtitle: `Password reset successfully for ${user.firstName} ${user.lastName}` });
      })
      .then((response) => response.data)
      .catch(() => {
        alerts.error({ subtitle: 'Password reset failed!' });
      });
  }

  static reset2FA(user) {
    return Promise.resolve(axios.put('/api/auth/reset-2fa', { id: user.id }))
      .tap(() => {
        alerts.success({ title: '2-Factor Auth Reset', subtitle: `2-Factor auth reset successfully for ${user.firstName} ${user.lastName}` });
      })
      .tap(this.logRequest)
      .then((response) => response.data)
      .catch(() => {
        alerts.error({ subtitle: 'Password reset failed!' });
      });
  }
}



// WEBPACK FOOTER //
// ./app/services/data/auth.js